
import { useState, useEffect } from "react";

export const useGroupBooking = (groupSize: number) => {
  const [groupNameInputs, setGroupNameInputs] = useState<string[]>([]);
  
  // Update group name inputs when group size changes
  useEffect(() => {
    const size = Math.max(1, Math.min(10, groupSize || 1));
    setGroupNameInputs(Array(size - 1).fill(""));
  }, [groupSize]);
  
  // Handle group name updates
  const updateGroupName = (index: number, value: string) => {
    const newNames = [...groupNameInputs];
    newNames[index] = value;
    setGroupNameInputs(newNames);
  };
  
  return {
    groupNameInputs,
    updateGroupName
  };
};
